import { getUserConfiguration } from 'owa-session-store';
import { SessionInfo, ComposeType, Actor } from '@qas/smartcompose-tslibrary/dist/src/session';
import { getOsInfo } from 'owa-user-agent';
import { getClientVersion, getClientId } from 'owa-config';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export default function buildSessionInfo(composeType: ComposeType): SessionInfo {
    const config = getUserConfiguration();
    const osInfo = getOsInfo();
    return {
        actor: new Actor(
            config.SessionSettings.UserPuid,
            isConsumer() ? 'MSA' : 'AAD',
            config.SessionSettings.TenantGuid,
            'User'
        ),
        application: {
            aadAppId: getClientId(),
            appName: 'WAC_Outlook',
            appVer: getClientVersion(),
        },
        device: {
            os: osInfo.os,
            osVer: osInfo.osVersion,
            userAgent: getUserAgentString(),
        },
        composeType: composeType,
    };
}

export function getUserAgentString() {
    return navigator?.userAgent ? navigator.userAgent : '';
}
